import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    marginBottom: theme.spacing(7),
    marginTop: theme.spacing(7),
    borderBottom: '1px solid #dadada',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  date: {
    backgroundColor: 'rgb(248 248 248)',
    position: 'absolute',
    display: 'inline-block',
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

const DateDivider = ({ date }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography className={classes.date} variant="caption">
        {moment(date).format('LL')}
      </Typography>
    </div>
  );
};

export default DateDivider;
